<template>
  <section class="search-bar">
    <form @submit.prevent="search">
      <input
        type="text"
        placeholder="Waar bent u naar op zoek?"
        @keydown.enter="search"
        v-model="sString"
      />
      <span class="clearbutton" v-show="sString.length > 0">
        <close-button color="white" @click="clearSearch"></close-button>
      </span>
      <button class="search-submit">
        <!-- zoek -->
        <svg class="trigger pointer" width="18" height="18" viewBox="0 0 18 18">
          <path
            fill="#979797"
            d="M13.7087003,11.7087003 L17.5,15.5 C18.0522847,16.0522847 18.0522847,16.9477153 17.5,17.5 C16.9477153,18.0522847 16.0522847,18.0522847 15.5,17.5 L11.7087003,13.7087003 C10.5086822,14.5237436 9.05995891,15 7.5,15 C3.35786438,15 0,11.6421356 0,7.5 C0,3.35786438 3.35786438,0 7.5,0 C11.6421356,0 15,3.35786438 15,7.5 C15,9.05995891 14.5237436,10.5086822 13.7087003,11.7087003 Z M7.5,13 C10.5375661,13 13,10.5375661 13,7.5 C13,4.46243388 10.5375661,2 7.5,2 C4.46243388,2 2,4.46243388 2,7.5 C2,10.5375661 4.46243388,13 7.5,13 Z"
          />
        </svg>
      </button>
    </form>
  </section>
</template>
<script>
import { mapStores } from 'pinia'
import { usePrintStoreStore } from '@/features/printstore/PrintStore.store'

export default {
  data() {
    return {
      sString: ''
    }
  },
  computed: {
    ...mapStores(usePrintStoreStore),
    searchOptions() {
      return this.printStoreStore.searchOptions
    }
  },
  methods: {
    async search() {
      const searchDefault = this.rootStore.theme.customFields.printStore
        .hideDefaultContent
        ? 0
        : 1

      this.sString = this.sString.trim()
      if (!this.sString) {
        return
      }
      this.printStoreStore.searchOptions.searchString = this.sString

      await this.printStoreStore.search({ d: searchDefault })
      await this.$router.push({ name: 'printStoreSearchResults' })
    },
    clearSearch() {
      this.sString = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.search-bar {
  display: flex;
  width: 220px;
  border: solid var(--sub-color) 1px;
  height: 36px;
  border-radius: 25px;
  align-items: center;
  background-color: white;
}

form {
  display: flex;
  flex-grow: 1;
  align-items: center;

  input {
    border-bottom: transparent;
    flex-grow: 1;
    background: transparent;
    padding: 8px 0px 8px 9px;
    margin: 0;
    height: 100%;
  }
}

.clearbutton {
  background: #cecece;
  width: 14px;
  height: 14px;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  flex-shrink: 0;
}

svg path {
  fill: var(--sub-color);
}

.search-submit {
  width: 35px;
  padding-right: 5px;
}

/* .option-button {
  //  color: var(--sub-color);
  margin: 0 5px;
}
 */
.pill-button {
  margin-right: 3px;
}

/* .sglass {
  padding: 0 10px;

  path {
    fill: var(--sub-color);
  }
}
 */
/* .vl {
  height: 18px;
  width: 1px;
  background-color: #4f4f4f;
}

:deep( .menu .menu-items {
  min-width: 200px;
  max-height: 240px;
  overflow-y: auto;
} */
</style>
